module.exports = __webpack_public_path__ + "media/images/services/06-f1ca24404e28d52d4139e5153590a3f4.jpg";